<rask-page
    pageTitle="{{ 'SORTIMENT_LIST_SOK' | translate }}"
    [actionShow]="canCreate"
    [actionFn]="create"
    actionTitle="{{'SORTIMENT_DETAIL_SKAPA_NY' | translate}}"
    noPadding>
    <ng-container headerContent>
        <form [formGroup]="sortimentForm" (ngSubmit)="search()">
            <div class="row">
                <rask-input aid="sortimentKod" class="col-1" label="{{ 'SORTIMENT_LIST_KOD' | translate }}" formControlName="code" [rule]=""></rask-input>
                <rask-input aid="sortimentNamn" class="col-2" label="{{ 'SORTIMENT_LIST_NAMN' | translate }}" formControlName="name" [rule]="">
                </rask-input>
                <rask-input aid="sortimentProduktgrupp" class="col-2" label="{{ 'SORTIMENT_LIST_PRODUKTGRUPP' | translate }}" formControlName="productgroup" [rule]="">
                </rask-input>
                <div class="col">
                    <rask-radiobutton-group label="{{ 'SORTIMENT_LIST_AKTIV' | translate }}" [buttons]="activetypes"
                    formControlName="active" [rule]=""></rask-radiobutton-group>
                    <rask-submit-button aid="sortimentSok" color="secondary">{{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}</rask-submit-button>
                </div>
            </div>
        </form>
    </ng-container>
    <rask-sortiment-list [sortiment]="sortiment"></rask-sortiment-list>
</rask-page>
